<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click="toogleView">
    <v-layout row wrap>
      <v-flex xs12 md8 text-xs-center text-sm-left>
        <v-layout row wrap>
          <v-flex xs12 md8 py-0>
            BRL {{deposit_value}}<v-icon class="arrow-icon-small">arrow_forward</v-icon> USD {{exchanged_value}}
            <p>{{transaction_id}}</p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4 py-0 text-md-right text-xs-center>
        <v-layout row wrap caption v-if="current_view == 'short'">
          <v-flex xs12 py-0>
            <v-icon v-if="step == 1">expand_more</v-icon>
            <v-icon v-if="!has_error && !payment_complete && step > 1">schedule</v-icon>
            <v-icon v-if="payment_complete">paid</v-icon>
            <v-icon v-if="has_error">error_outline</v-icon>
          </v-flex>
          <v-flex v-if="step != 1 && !has_error && !payment_complete" xs12 py-0>
            {{remaining_seconds}}
          </v-flex>
        </v-layout>
      </v-flex>

      <v-expand-transition>
        <v-flex xs12 mt-3 v-if="current_view === 'detailed'" @click="stopUnlessUploading">
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="step > 1">Payment Info</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="step > 2">Scan QR Code</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :rules="[() => !has_error]">
                {{!error_message ? "Done" : error_message}}
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-content step="1">
              <v-layout align-center justify-center column fill-height>
                <v-flex class="xs12 text-font">
                  {{ i18n("Valor a receber") }}
                </v-flex>
                <v-flex>
                  <v-sheet class="input-dimensions ma-2">
                    <v-currency-field
                      v-model="exchanged_value"
                      v-bind="currency_config"
                      :error-messages="error"
                      :error="has_error"
                      prefix="USD"
                      outline
                    ></v-currency-field>
                    <v-text-field
                      box
                      v-model="customer_email"
                      :rules="[this.email_rule]"
                      label="E-mail (optional)"
                    ></v-text-field>
                  </v-sheet>

                  <v-btn
                    :loading="loading"
                    :disabled="exchanged_value == 0"
                    @click="createQRCodeTransaction()"
                    class="flex-1 btn-colors btn-dimensions">
                    {{ i18n("Prosseguir") }}
                    <v-icon right dark>qr_code</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-layout align-center column fill-height>
                <v-flex class="xs12 text-font">
                  {{ i18n(step2_message) }}
                </v-flex>
                <v-flex v-if="!this.has_error">
                  <v-flex class="xs12 lg6">
                    <qrcode-vue v-if="qrcode_string!==''" :value="qrcode_string" :size="300" level="H" />
                  </v-flex>
                  <v-flex class="xs12 info-dimensions">
                    {{ i18n("Valor: ") + this.deposit_value + ' BRL'}}
                    <v-progress-linear v-model="remaining_percent"></v-progress-linear>
                    <v-icon>schedule</v-icon>
                    {{ i18n("Expira em ") + this.remaining_seconds + i18n(" segundos")}}
                  </v-flex>
                </v-flex>
                <v-flex class="xs12 justify-flex-end">
                  <v-btn :dark="false" class="flex-1" @click="newPaymentWindow()">
                    <v-icon left dark>add</v-icon>
                    {{ i18n("Novo Pagamento") }}
                  </v-btn>
                  <v-btn class="flex-1 btn-colors" v-if="!has_error" @click="step = 3">
                    {{ i18n("Prosseguir") }}
                  </v-btn>
                  <v-btn :dark="false" flat class="flex-1" v-if="has_error" @click="closeComponent()">
                    {{ i18n("Fechar") }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-layout v-if="!payment_complete" align-center column fill-height>
                <v-flex class="xs12 text-font">
                  <p>{{ i18n("Aguarde enquanto o Pix é validado. Este processo pode levar até 1 minuto.") }}</p>
                  <p>{{ i18n("Não atualize a página, isso será feito automaticamente após a identificação do pagamento.") }}</p>
                </v-flex>
                <v-flex class="group pa-2">
                  <v-icon x-large>hourglass_top</v-icon>
                </v-flex>
                <v-flex class="xs12 justify-flex-end">
                  <v-btn class="flex-1 btn-colors" @click="step = 2" v-if="!payment_complete">
                    <v-icon left dark>arrow_back</v-icon>
                    {{ i18n("Ver QR Code") }}
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-layout v-if="payment_complete" align-center column fill-height>
                <v-flex class="xs12 text-font">
                  {{ i18n("Pagamento recebido com sucesso") }}
                </v-flex>
                <v-flex class="group pa-2">
                  <v-icon x-large>check_circle</v-icon>
                </v-flex>
                <v-flex class="xs12">
                  <v-btn class="flex-1 btn-colors" @click="gotoPage('/transactions')">
                    <v-icon left dark>attach_money</v-icon>
                    {{ i18n("Transações") }}
                  </v-btn>
                  <v-btn :dark="false" class="flex-1" @click="newPaymentWindow()">
                    <v-icon left dark>add</v-icon>
                    {{ i18n("Novo Pagamento") }}
                  </v-btn>
                  <v-btn color="error" @click="closeComponent()">
                    {{ i18n("Fechar") }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-layout align-center justify-center column fill-height>
                <v-flex class="xs12 text-font" style="text-align: center">
                  {{ i18n(error_message) }}
                </v-flex>
                <v-flex class="xs12 justify-flex-end">
                  <v-btn :dark="false" class="flex-1" @click="newPaymentWindow()">
                    <v-icon left dark>add</v-icon>
                    {{ i18n("Novo Pagamento") }}
                  </v-btn>
                  <v-btn class="flex-1 btn-colors" v-if="!has_error" @click="step = 3">
                    {{ i18n("Prosseguir") }}
                  </v-btn>
                  <v-btn :dark="false" flat class="flex-1" v-if="has_error" @click="closeComponent()">
                    {{ i18n("Fechar") }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>

          </v-stepper>
        </v-flex>
      </v-expand-transition>
    </v-layout>
  </v-flex>
</template>

<script>

import QrcodeVue from 'qrcode.vue'

export default {
  name: "GlobalPixForm",
  components: {
    QrcodeVue,
  },
  props: {
    __ref__: {
      type: String,
      required: true
    },
    prop_transaction_id: {
      type: String,
    },
    socketConnected: {
      type: Boolean,
      default: false
    },
    prop_qrcode_string: {
      type: String,
      default: ""
    },
    prop_value: {
      type: String,
    },
    prop_deposit_value: {
      type: String,
      default: "0.0"
    },
    prop_exchanged_value: {
      type: String,
      default: "0.0",
    },
    prop_createdAt: {
      type: [String, Date],
      default: ""
    },
    prop_step: {
      type: Number,
      default: 1
    },
    prop_status: {
      type: String,
      default: "without-transaction"
    },
    prop_payment_complete: {
      type: Boolean,
      default: false,
    },
    prop_has_error: {
      type: Boolean,
      default: false,
    },
    prop_error_message: {
      type: String,
      default: ""
    },
  },
  created() {
    this.loadProps()
  },
  mounted() {
    if (this.createdAt && this.status == "pending") {
      this.elapsedTimeFromNow()
      this.startTimer()
    }
  },
  data() {
    return {
      error: "",
      loading: false,
      customer_email: "",
      elapsed_time: 0,
      timer_limit: 600,
      timer_interval: null,
      current_view: 'detailed',
      transaction_id: null,
      qrcode_string: "",
      value: "0.0",
      deposit_value: "0.0",
      exchanged_value: "0.0",
      createdAt: null,
      step: 1,
      status: "",
      payment_complete: false,
      has_error: false,
      error_message: "",
      currency_config: {
        decimal: ",",
        thousands: ".",
      },
      renderComponent: true,
      email_rule: (val) => {
        return ((/([\w\.]+)@([\w\.]+)\.(\w+)|^$/g).test(val) || 'Invalid')
      }
    }
  },
  methods: {
    loadProps(){
      this.transaction_id   = this.prop_transaction_id
      this.qrcode_string    = this.prop_qrcode_string
      this.value            = this.prop_value
      this.deposit_value    = this.prop_deposit_value
      this.exchanged_value  = this.prop_exchanged_value
      this.createdAt        = this.prop_createdAt
      this.step             = this.prop_step
      this.status           = this.prop_status
      this.payment_complete = this.prop_payment_complete
      this.has_error        = this.prop_has_error
      this.error_message    = this.prop_error_message
    },
    i18n(str) {
      return this.$root.l(str)
    },
    elapsedTimeFromNow() {
      const expireDate = new Date(this.createdAt)
      const now = new Date()
      const diff = now.getTime() - expireDate.getTime()

      this.elapsed_time = Math.floor(diff / 1000)
      return this.elapsed_time
    },
    joinInChannel() {
      if (this.elapsedTimeFromNow() < this.timer_limit) {
        const self = this;
        const events = [
          { name: 'receive_status', action: _app =>  self.onStatusReceived},
          { name: 'payment_received', action: _app =>  self.onPaymentReceived},
          { name: 'to_refund', action: _app =>function(payload){ self.onTransactionRefunded(payload)}}
        ]
        this.$root.store.connectToChannel(`global_pix:${this.transaction_id}`, events)
        this.startTimer()
      }
    },
    createQRCodeTransaction() {
      this.loading = true
      const self = this;
      let successCallback = (response) => {
        if (response.body.data.status == 'pending') {
          const {id, dynamic_pix_code, value, exchanged_value} = response.body.data
          self.createdAt = new Date()
          self.qrcode_string = dynamic_pix_code
          self.deposit_value = parseFloat(value).toFixed(2)
          self.exchanged_value = parseFloat(exchanged_value).toFixed(2)
          self.transaction_id = id
          self.status = "pending"
          self.payment_complete = false
          self.joinInChannel()
          self.$emit('onTransactionUpdated',self.getState())
        } else {
          self.has_error = true
          self.error = self.i18n('Pagamento não realizado, tente novamente.')
        }
        self.loading = false
      }
      let errorCallback = (response) => {
        self.has_error = true
        self.loading = false

        switch (response.status) {
          case 401:
            self.error = self.i18n('Sessão expirada, redirecionando para o login...')
            setTimeout(() => self.$router.push('/sign_in'), 1500)
            break;
          case 422:
            self.error = self.i18n('As contas não foram configuradas corretamente. Contate o suporte.')
            break;
          case 500:
            self.error = self.i18n('Erro interno. Contate o suporte.')
            break;
          default:
            console.log('errorCallback', response)
            break;
        }
      }

      let token = this.$cookies.get('api_token')

      let payload = {
        exchange_currency: 'USD',
        exchanged_value: this.exchanged_value,
        email: this.customer_email,
        use_global_pix: true
      }

      this.step = 2

      this.$http
        .post(this.$root.urls.customer__scheduled_bank_transactions, {transaction: payload}, { headers: { Authorization: `Bearer ${token}` }})
        .then(successCallback, errorCallback)
      return
    },
    onStatusReceived(payload) {
      switch(payload.status) {
        case "canceled":
          this.onTransactionRefunded(payload)
          this.disconnectFromChannel()
          break;
        case "pending":
          break;
        case null:
          this.closeComponent()
          this.disconnectFromChannel()
          break;
        default:
          this.onPaymentReceived(payload)
          break;
      }
    },
    onPaymentReceived(payload) {
      if(payload.status == 'pending') return
      this.status = "paid"
      this.step = 3
      this.payment_complete = true
      this.has_error = false
      this.stopTimer()
      this.$emit('onTransactionUpdated', this.getState())
    },
    onTransactionRefunded(payload) {
      this.status = "refused"
      this.step = 4
      this.has_error = true
      this.payment_complete = false
      let msg = payload.canceled_reason;
      if(this.$root.lang == 'pt'){
        switch(payload.canceled_reason){
          case 'Value received was greater than charged and will be refunded':
            msg = 'O valor recebido foi superior ao cobrado e será reembolsado'
            break;
          case 'Value received was lesser than charged and will be refunded':
            msg = 'O valor recebido foi inferior ao cobrado e será reembolsado'
            break;
          case 'Payer document number did not match. Received value will be refunded':
            msg = 'O número do documento do pagador não coincide. O valor recebido será reembolsado'
            break;
        }
      }
      this.error_message = this.i18n(msg)
      this.stopTimer()
      this.$emit('onTransactionUpdated',  this.getState())
    },
    setTimeout(){
      if (this.status !== "pending") return
      this.status = "expired"
      this.stopTimer()
      this.has_error = true
      this.error_message = this.i18n('O tempo para se fazer o pagamento esgotou. Por favor, crie um novo código.')
      this.disconnectFromChannel()
      this.$emit('onTransactionUpdated',  this.getState())
    },
    getState(){
      return {
        id: this.transaction_id,
        step: this.step,
        createdAt: this.createdAt,
        status: this.status,
        payment_complete: this.payment_complete,
        qrcode_string: this.qrcode_string,
        deposit_value: this.deposit_value,
        exchanged_value: this.exchanged_value,
        has_error: this.has_error,
        error_message: this.error_message,
        __ref__: this.__ref__
      }
    },
    closeComponent() {
      this.disconnectFromChannel();
      this.$emit('onCloseTransaction', this.getState())
    },
    resetComponent() {
      this.step = 1
      this.has_error = false
      this.error_message = ""
      this.loading = false
      this.elapsed_time = 0
      this.customer_email = ""
      this.deposit_value = 0.0
      this.exchanged_value = 0.0
      this.qrcode_string = ""
      this.payment_complete = false
      this.error=false
      this.status = "without-transaction"
      this.stopTimer()
    },
    stopTimer(){
      clearInterval(this.timer_interval)
    },
    startTimer() {
      this.stopTimer()
      let self = this;
      this.timer_interval = setInterval(() => self.elapsedTimeFromNow() , 1000);
    },
    newPaymentWindow() {
      if (this.transaction_id){
        this.current_view = 'short'
        this.$emit('onCreateNewPixTransaction')
      } else {
        this.resetComponent()
      }
    },
    toogleView(e) {
      if (!e || e.target.type !== 'file') {
        this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
        e && e.preventDefault()
      }
    },
    stopUnlessUploading(e) {
      if (e.target.type === 'file') {
        return true
      } else {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
    gotoPage(path) {
      this.$router.push(path).catch(err => {})
    },
    watch_elapsed_time(value) {
      if (value >= this.timer_limit) {
        this.setTimeout()
      }
    },
    disconnectFromChannel() {
      this.$root.store.disconnectFromChannel(`global_pix:${this.transaction_id}`);
    }
  },
  watch: {
    socketConnected: function(newValue, oldValue){
      if(oldValue == false && newValue == true && this.transaction_id != 'undefined') {
        this.joinInChannel()
      }
    },
    elapsed_time: {
      handler(value) {
        this.watch_elapsed_time(value)
      },
      immediate: true
    }
  },
  computed: {
    remaining_seconds() {
      return this.timer_limit - this.elapsed_time
    },
    remaining_percent() {
      return (this.remaining_seconds / this.timer_limit) * 100
    },
    step2_message() {
      let message = ""
      if (this.has_error) {
        message = this.error_message || this.error
      } else {
        message = this.i18n('Escaneie o QR Code para efetuar o pagamento.')
      }
      return message
    }
  },
}
</script>

<style scoped>
.text-font {
  font-size: 15pt;
  margin: 20px
}

.btn-colors {
  background-color: var(--secondary-button-background-color) !important;
  color: white !important;
}

.btn-dimensions {
  height: 60px;
  width: 100%;
  font-size: large;
}

.info-dimensions {
  text-align: center;
  font-size: 14pt;
  margin-bottom: 30px;
}

.input-dimensions {
  font-size: 22px;
  padding: 80px;
}

.flex-1 {
  flex: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/GlobalPixForm.vue